
import en from './en/common';
import ar from './ar/common';
import es from './es/common';

export default {
  en: {
    translation: en,
  },
  ar: {
    translation: ar,
  },
  es: {
    translation: es,
  },
};
